import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';

import { formatNumber, milesToKm } from './workoutHealthData';
import {
  HeartIcon,
  StatsRow,
  StatItem,
  DetailsToggle,
} from './styles';
import texts from './texts.json';

/**
 * One workout's synced stats on a single line, with the toggle that opens its details.
 */
const WorkoutHealthStats = ({ activity, isExpanded, onToggle }) => {
  const distanceKm = milesToKm(activity.distance);
  return (
    <StatsRow>
      <StatItem>{`${Math.round(activity.duration / 60)} ${texts.min}`}</StatItem>
      {distanceKm > 0 && <StatItem>{`${distanceKm.toFixed(1)} ${texts.km}`}</StatItem>}
      <StatItem>{`${formatNumber(activity.activeCalories)} ${texts.kcal}`}</StatItem>
      {!!activity.averageHeartRate && (
        <StatItem>
          <HeartIcon />
          {format(texts.averageMax, {
            average: Math.round(activity.averageHeartRate),
            max: Math.round(activity.maxHeartRate ?? activity.averageHeartRate),
          })}
        </StatItem>
      )}
      <DetailsToggle
        type="button"
        $isExpanded={isExpanded}
        aria-expanded={isExpanded}
        onClick={(event) => {
          // The day row toggles its own progression section on click.
          event.stopPropagation();
          onToggle();
        }}
        onKeyDown={(event) => event.stopPropagation()}
      >
        {isExpanded ? texts.hide : texts.details}
      </DetailsToggle>
    </StatsRow>
  );
};

WorkoutHealthStats.propTypes = {
  activity: PropTypes.shape({
    duration: PropTypes.number,
    distance: PropTypes.number,
    activeCalories: PropTypes.number,
    averageHeartRate: PropTypes.number,
    maxHeartRate: PropTypes.number,
  }).isRequired,
  isExpanded: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

WorkoutHealthStats.defaultProps = {
  isExpanded: false,
};

export default WorkoutHealthStats;
